import { useEffect, useRef, useState } from 'react'
import { Dropdown, Loader, Modal, Table } from 'sfy-react'
import { postRequestAsync } from '../../../genericApi'
import './ApproverListModal.scss'

const ApproverListModal = ({ showModal, setShowModal }) => {
  const [approverList, setApproverList] = useState([])
  const [appsList, setAppsList] = useState([])
  const [selectedApp, setSelectedApp] = useState({})
  const [isApproverListLoading, setIsApproverListLoading] = useState(false)
  const hasFetchedAppsRef = useRef(false)

  const closeModal = () => {
    setShowModal(false)
    setSelectedApp({})
  }

  const getCentralAppsList = async () => {
    try {
      const response = await postRequestAsync('/user/getCentralAppsList', {})

      let modifiedResponse =
        response &&
        response?.data?.centralAppsList?.map((centralApp) => {
          let _centralAppsList = {
            id: centralApp['centralAppsID'],
            value: centralApp['appName'],
            label: centralApp['appName'],
          }

          return _centralAppsList
        })
      setAppsList(modifiedResponse)
    } catch (e) {
      console.log(e)
    }
  }

  const getApproverList = async (payload) => {
    setIsApproverListLoading(true)
    try {
      const res = await postRequestAsync('/user/getCentralAppsApproverList', payload)
      setApproverList(res?.data?.approverListByApp ?? [])
    } catch (e) {
      console.log(e)
    } finally {
      setIsApproverListLoading(false)
    }
  }

  useEffect(() => {
    if (!showModal) {
      hasFetchedAppsRef.current = false
      return
    }
    if (!hasFetchedAppsRef.current) {
      hasFetchedAppsRef.current = true
      getCentralAppsList()
    }
    getApproverList(selectedApp?.value ? { centralAppsID: selectedApp.id } : {})
  }, [showModal, selectedApp])

  const handleAppChangeChange = (app) => {
    setSelectedApp(app)
  }

  const getApproversDisplayText = (approverListByItem) => {
    if (!approverListByItem?.length) return '-'
    return approverListByItem
      .map((approver) => approver?.name)
      .filter(Boolean)
      .join(', ')
  }

  return (
    <Modal showModal={showModal} closeModal={closeModal} showCloseBtn={true} className='approver-list-modal'>
      <Modal.Header className='modal-header'>
        <h3> Module Approver List</h3>
      </Modal.Header>
      <Modal.Body className='modal-body'>
        <div className='central-app_dropdown'>
          <div className='label'>Central App</div>
          <Dropdown
            id='central-app-dropdown'
            options={appsList}
            placeholder={'Select Central App'}
            value={selectedApp?.value || ''}
            handleOnChange={handleAppChangeChange}
            filterBy='value'
            searchText={'Central App'}
            showTooltip
            showClearButton
          />
        </div>
        {isApproverListLoading ? (
          <div className='approver-list-modal__loader'>
            <Loader />
          </div>
        ) : (
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.Heading>App Name</Table.Heading>
                <Table.Heading>Approvers</Table.Heading>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {approverList?.length > 0 ? (
                approverList.map((item) => (
                  <Table.Row key={item?.centralAppsID}>
                    <Table.Data>{item?.appName ?? '-'}</Table.Data>
                    <Table.Data>{getApproversDisplayText(item?.approverList)}</Table.Data>
                  </Table.Row>
                ))
              ) : (
                <Table.Row>
                  <Table.Data colSpan={2}>No data available</Table.Data>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default ApproverListModal
